import { render } from "./EditReclamation.vue?vue&type=template&id=a775b300&ts=true"
import script from "./EditReclamation.vue?vue&type=script&lang=ts"
export * from "./EditReclamation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__